import { useEffect, useMemo } from "react";

const setMeta = (attribute, key, value) => {
  const selector = `meta[${attribute}="${key}"]`;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value || "");
};

const setCanonical = (url) => {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
};

const setSchema = (id, schema) => {
  document.getElementById(id)?.remove();
  if (!schema) {
    return;
  }
  const script = document.createElement("script");
  script.id = id;
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
};

export const SeoHead = ({ seo }) => {
  const signature = JSON.stringify(seo || {});
  const resolvedSeo = useMemo(() => JSON.parse(signature), [signature]);

  useEffect(() => {
    if (!resolvedSeo.title) {
      return undefined;
    }

    document.title = resolvedSeo.title;
    setMeta("name", "description", resolvedSeo.description);
    setMeta("name", "robots", resolvedSeo.noIndex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:site_name", "Eira Products");
    setMeta("property", "og:type", resolvedSeo.type || "website");
    setMeta("property", "og:title", resolvedSeo.title);
    setMeta("property", "og:description", resolvedSeo.description);
    setMeta("property", "og:url", resolvedSeo.canonical);
    setMeta("property", "og:image", resolvedSeo.image || "");
    setMeta("name", "twitter:card", resolvedSeo.image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", resolvedSeo.title);
    setMeta("name", "twitter:description", resolvedSeo.description);
    setMeta("name", "twitter:image", resolvedSeo.image || "");
    setCanonical(resolvedSeo.canonical);
    if (resolvedSeo.schemaId) {
      setSchema(resolvedSeo.schemaId, resolvedSeo.schema);
    }

    return () => {
      if (resolvedSeo.schemaId) {
        document.getElementById(resolvedSeo.schemaId)?.remove();
      }
    };
  }, [resolvedSeo]);

  return null;
};